<script>
	import SvelteTooltip from './SvelteTooltip.svelte'
	export let title = null;
	export let subtitle = null;
	export let instiRecommendation = false;
</script>

<style>
	.iq-card-body {
		color: black;
	}
	.findings-card {
		border: 1px solid lightgray; 
		padding: 1rem 0;
		border-radius: 15px;
		margin-bottom: 1.3rem;
	}
	.pSubtitle {
		color: black;
		font-size: 0.8rem;
	}

	#header-title {
		display: flex;
    	align-items: center;
    	/* justify-content: center; */
	}

	.ri-information-line {
		float: right; 
		font-size: 1.3rem;
		margin-left: 0.5rem;
		color: rgb(8, 156, 172);
	}

	#card-title {
		float: left;
	}
</style>

<div class="iq-card iq-card-block iq-card-stretch iq-card-height findings-card">
	<slot name="header">
		{#if title != null}
			<div class="iq-card-header d-flex justify-content-between">
				<div class="iq-header-title">
					<div id="header-title">
						{#if instiRecommendation}
							<h5 class="h5 card-title" id="card-title">{title}</h5>
						{:else}
							<h5 class="h5 card-title">{title}</h5>
						{/if}
						
						{#if instiRecommendation}
							<SvelteTooltip tip="This is a general recommendation for patient's like this based on the patient's risk and the opinion from experts at your institution." top>
								<i class="ri-information-line"></i>
							</SvelteTooltip>
						{/if}
					</div>
					{#if subtitle != null}<p class="pSubtitle">{subtitle}</p>{/if}
				</div>
			</div>
		{/if}
	</slot>
	<div class="iq-card-body pt-1">
		<slot />
	</div>
</div>
